import Quill from 'quill';

const BlockEmbed: any = Quill.import('blots/block/embed');

/**
 * Il widget meteo dentro l'articolo, come vive nel markup salvato.
 *
 * E' solo un segnaposto vuoto: il sito pubblico lo sostituisce con il widget
 * (infooggi-fe-slider, services/corpo-meteo.js) che mostra pioggia e
 * temperature del comune in cui si trova chi legge, e sulla pagina AMP con
 * un invito al meteo. Vuoto perche' il testo dell'articolo finisce anche nei
 * feed e nelle anteprime: li' un div senza contenuto non si vede.
 *
 * Quello che la redazione vede nell'editor (la carta con il cielo) e' tutto
 * CSS, in articolo.component.scss: nel markup non entra niente.
 */
export const MARKUP_METEO = '<div class="meteo-articolo" data-meteo-articolo=""></div>';

export class EmbedMeteo extends BlockEmbed {
  static blotName = 'meteo';
  static tagName = 'DIV';
  static className = 'meteo-articolo';

  static create() {
    const node = super.create();
    node.setAttribute('data-meteo-articolo', '');
    return node;
  }

  static value(): boolean {
    return true;
  }
}

Quill.register(EmbedMeteo);
